import { Database } from "../../../constants/schema.js";
//#region src/engine/modules/relationship/referenceType.ts
var SERIAL = "serial";
var POSTGRESQL_SERIALS = /* @__PURE__ */ new Map([
	["smallserial", "smallint"],
	["serial2", "smallint"],
	["serial4", "integer"],
	["bigserial", "bigint"],
	["serial8", "bigint"]
]);
var SERIAL_BY_DATABASE = /* @__PURE__ */ new Map([
	[Database.PostgreSQL, "integer"],
	[Database.MySQL, "bigint unsigned"],
	[Database.MariaDB, "bigint unsigned"]
]);
var toTypeKey = (dataType) => dataType.trim().toLowerCase();
function isSerialType(dataType) {
	const key = toTypeKey(dataType);
	return key === SERIAL || POSTGRESQL_SERIALS.has(key);
}
function toReferenceDataType(dataType, database) {
	const key = toTypeKey(dataType);
	const reference = key === SERIAL ? SERIAL_BY_DATABASE.get(database) : POSTGRESQL_SERIALS.get(key);
	if (!reference) return dataType;
	const name = dataType.trim();
	return name === name.toUpperCase() ? reference.toUpperCase() : reference;
}
//#endregion
export { isSerialType, toReferenceDataType };
